import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
//import { useTheme } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Clear from '@material-ui/icons/Clear'
import Button from '@material-ui/core/Button'
import DialogActions from '@material-ui/core/DialogActions'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import FormLabel from '@material-ui/core/FormLabel'
import FormGroup from '@material-ui/core/FormGroup'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown'
//import Grid from '@material-ui/core/Grid'
import buyerClient from 'config/api/BuyerClient'
import admaticClient from 'config/api/AdmaticClient'
import { onError } from 'config/lib/errorLib'

import componentStyles from 'assets/theme/views/admin/notifications.js'
import componentStylesDialog from 'assets/theme/components/dialog.js'

const useStyles = makeStyles(componentStyles)
const useStylesDialog = makeStyles(componentStylesDialog)

const Transition = React.forwardRef(function Transition(props, ref) {
  	return <Slide direction='down' ref={ref} {...props} />
})

export default function AddTeamMemberModal(props) {
	const classes = {...useStyles(), ...useStylesDialog()}
  	//const theme = useTheme()
  	const api = props.admatic ? new admaticClient() : new buyerClient()

  	const buyerDetails = props.buyerDetails

  	const [name, setName] = useState('')
  	const [email, setEmail] = useState('')
  	const [phone, setPhone] = useState('')
  	const [permissions, setPermissions] = useState(props.admatic ? 'admin' : 'buyer')
  	const [password, setPassword] = useState('')

  	async function addTeamMember() {
  		try {
  			if(props.admatic) {
	  			let teamMember = await api.addTeamMember(name, email, phone, permissions, password)
	  			console.log('team member: ', teamMember)
	  		}
	  		else {
	  			const buyerId = buyerDetails.buyerId
  				const buyerName = buyerDetails.name
	  			let teamMember = await api.addTeamMember(buyerId, buyerName, name, email, phone, permissions, password)
	  			console.log('team member: ', teamMember)
	  		}

  			//props.refreshTeamMembers()
  			props.openSuccessAlert('Team member added! Once they have clicked the email confirmation and logged in they will appear here.')
  			props.close()
  		} catch(e) {
  			onError(e)
  		}
  	}

  	function checkFields() {
  		if (name.length > 0 && email.length > 0 && phone.length > 0 && permissions && password.length > 0) {
  			return false
  		}
  		else {
  			return true
  		}
  	}

	return (
		<Dialog
			open={props.isOpen}
			TransitionComponent={Transition}
			keepMounted
			onClose={() => props.close()}
			aria-labelledby='alert-dialog-slide-title'
			aria-describedby='alert-dialog-slide-description'
		>
			<div className={classes.dialogHeader}>
				<Typography
					variant='h5'
					component='h5'
					className={classes.dialogTitle}
				>
					Add Team Member
				</Typography>
				<IconButton onClick={() => props.close()}>
					<Clear />
				</IconButton>
			</div>
			
			<DialogContent>
				<FormGroup>
                  	<FormLabel>Name</FormLabel>
                  	<OutlinedInput
                    	fullWidth
                    	type='text'
                    	placeholder='John Smith'
                    	onChange={(e) => setName(e.target.value)}
                  	/>
                </FormGroup>
                <FormGroup>
                  	<FormLabel>Email</FormLabel>
                  	<OutlinedInput
                    	fullWidth
                    	type='email'
                    	placeholder='john@example.com'
                    	onChange={(e) => setEmail(e.target.value)}
                  	/>
                </FormGroup>
                <FormGroup>
                  	<FormLabel>Phone</FormLabel>
                  	<OutlinedInput
                    	fullWidth
                    	type='phone'
                    	placeholder='+353872234415'
                    	onChange={(e) => setPhone(e.target.value)}
                  	/>
                </FormGroup>
                <FormGroup>
                  	<FormLabel>Permissions</FormLabel>
                  	<FormControl variant='outlined' fullWidth>
                    	<Select
                      		multiple={false}
                      		IconComponent={KeyboardArrowDown}
                      		value={permissions}
                      		onChange={(e) => setPermissions(e.target.value)}
                    	>
                    		{!props.admatic &&
                      			<MenuItem value={'buyer'}>Buyer</MenuItem>
                      		}
                      		<MenuItem value={'admin'}>Admin</MenuItem>
                    	</Select>
                  	</FormControl>
            	</FormGroup>
            	<FormGroup>
                  	<FormLabel>Password</FormLabel>
                  	<OutlinedInput
                    	fullWidth
                    	type='text'
                    	placeholder='csgw@2a44'
                    	onChange={(e) => setPassword(e.target.value)}
                  	/>
            	</FormGroup>
            	<Box
                    component='p'
                    marginBottom='1rem'
                    fontWeight='300'
                    lineHeight='1.7'
                    fontSize='1rem'
                >
                    This password is temporary and should be changed by the team member when they log in for the first time
                </Box>
			</DialogContent>
			
			<DialogActions>
				<Button
					onClick={() => props.close()}
					color='primary'
				>
					Cancel
				</Button>
			
				<Button
					component={Box}
					onClick={() => addTeamMember()}
					color='primary'
					marginLeft='auto!important'
					variant='contained'
					disabled={checkFields()}
				>
					Add
				</Button>
			</DialogActions>
		</Dialog>
	)
}